export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const CATEGORY_PROCESSING = "CATEGORY_PROCESSING";
export const STOP_CATEGORY_PROCESSING = "STOP_CATEGORY_PROCESSING";
